import { render, staticRenderFns } from "./CreditDebitTable.vue?vue&type=template&id=458c99b6&scoped=true"
import script from "./CreditDebitTable.vue?vue&type=script&lang=js"
export * from "./CreditDebitTable.vue?vue&type=script&lang=js"
import style0 from "./CreditDebitTable.vue?vue&type=style&index=0&id=458c99b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c99b6",
  null
  
)

export default component.exports